angular.module('ikeweb.user').controller('BillingStatusController', ['$rootScope', '$scope', 'loginService', 'billingService', 'events', '$location', 'subscriptionActionService', 'pubSubService', 'userTopics',
    function($rootScope, $scope, loginService, billingService, events, $location, subscriptionActionService, pubSubService, userTopics) {

        var isOnTrial = false;
        var canTrial = false;
        var shouldSubscribe = false;
        var trialDaysRemaining = -1;
        $scope.canTrial = false;

        function update() {
            if (!loginService.getLoggedInUser()) {
                isOnTrial = false;
                canTrial = false;
                trialDaysRemaining = -1;
                shouldSubscribe = false;
                return;
            }

            subscriptionActionService.isOnTrial().then(function(value) {
                isOnTrial = value;
                if (isOnTrial) {
                    billingService.getTrialDaysRemaining().then(function(value) {
                        trialDaysRemaining = value;
                    });
                }
            });
            subscriptionActionService.shouldSubscribe().then(function(value) {
                shouldSubscribe = value;
            });

            subscriptionActionService.canTrial().then(function(trial) {
                canTrial = trial;
                $scope.canTrial;
            });

        }

        this.navToUpgrade = function() {
            $location.path('billing');
        };

        this.getTrialDaysRemaining = function() {
            return trialDaysRemaining;
        };

        this.showTrialDaysRemaining = function() {
            return isOnTrial && trialDaysRemaining > -1;
        };

        this.shouldSubscribe = function() {
            return shouldSubscribe && !canTrial;
        };
        this.canTrial = function() {
            return canTrial;
        };

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], update);
        });

        pubSubService.subscribe(userTopics.CREDITCARD.UPDATED, update);
        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(userTopics.CREDITCARD.UPDATED, update);
        });

        $rootScope.$on('$routeChangeSuccess', update);

        update();
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/status/billing.status.controller.js
// module id = 155
// module chunks = 0